import { useTranslation } from "react-i18next";
import singleMode from "./selectBaseSingle";
import multiMode from "./selectBaseMulti";
import { rawItemsNew } from "../filters/useFilterPreferences";

import collatorSort from "utils/collatorSort";

export default ({ initial, multiple }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const items = rawItemsNew.map((item) => ({
		content: t(`filtersAndSelectors:preferences.${item.key}`),
		value: item.key,
		selected: !initial.includes(item.key),
		category: item.category,
	}));

	const sortedItems = collatorSort(
		collatorSort(items, "content"),
		"selected"
	);

	const computedInitial = initial.map((preference) => ({
		value: sortedItems.find((item) => item.value === preference)?.value,
	}));

	return {
		items: sortedItems,
		isMultiple: multiple,
		...(multiple
			? multiMode({ items: sortedItems, initial: computedInitial })
			: singleMode({ items: sortedItems, initial: computedInitial })),
	};
};
